export default {
  title: 'Diseño Instruccional · Documento',
  breadcrumb: 'Documento Diseño Instruccional',
  openButton: 'Ver como documento',
  openTooltip:
    'Ver el Diseño Instruccional completo como documento: el recorrido de cada Módulo con sus piezas, la triangulación y el calendario.',
  backToDesign: 'Volver al Diseño Instruccional',
  print: 'Imprimir',
  loadError: 'No se pudo cargar el documento del Diseño Instruccional.',
  noInstrument: 'Sin instrumento',
  noEvaluations: 'Este diseño todavía no tiene evaluaciones.',

  identityTitle: 'La asignatura y el diseño',
  summaryTitle: 'Síntesis del diseño',
  pathTitle: 'El recorrido',
  showTexts: 'Incluir los textos de cada pieza',
  unitsTitle: 'Triangulación por Unidad',
  weeklyTitle: 'Calendario',
  schemeTitle: 'Evaluaciones',
  bibliographyTitle: 'Bibliografía',

  fieldCode: 'Código',
  fieldProfile: 'Programa',
  fieldPlanLevel: 'Nivel',
  fieldCredits: 'Créditos',
  fieldWeeks: 'Semanas',
  fieldModality: 'Modalidad',
  fieldMethod: 'Modelo instruccional',

  counterModules: 'Módulos',
  counterActivities: 'Actividades',
  counterEvaluations: 'Evaluaciones',
  counterHours: 'Horas asignadas / del Programa',
  counterAutonomous: 'Horas de trabajo autónomo',
  counterWeighing: 'Ponderación',

  moduleUntitled: 'Módulo {order}',
  moduleMeta: '{pieces} piezas · {hours} h · {weighing}%',
  moduleEmpty: 'Este Módulo todavía no tiene piezas.',
  loosePieces: 'Piezas sin Módulo',
  pathEmpty: 'Este diseño todavía no tiene piezas.',

  rowStrategies: 'Se trabaja con',
  rowEvidences: 'Queda como evidencia',
  rowEnvironments: 'Ambiente',
  rowResources: 'Recursos',
  rowBibliography: 'Bibliografía',
  rowContents: 'Contenidos',
  rowParticipation: 'Participación',

  textDescription: 'De qué trata',
  textOrientation: 'Orientación',
  textStudent: 'Instrucciones para el estudiante',
  textProfessor: 'Instrucciones para el docente',

  unitMeta: '{activities} Actividades · {evaluations} Evaluaciones',
  unitMoments: 'Momentos que recorre',
  unitShared: 'Coherencia',
  unitNoIndicators: 'Esta Unidad no tiene Indicadores cargados.',
  sharedStrategies: 'Se enseña y se evalúa con {names}',
  noSharedStrategies:
    'Lo que se enseña y lo que se evalúa no comparten estrategia',
  sharedEvidences: 'Produce y recoge {names}',
  noSharedEvidences: 'La evidencia que se produce no es la que se recoge',
  notComparable:
    'Falta declarar estrategias o evidencias en uno de los dos lados, así que todavía no hay nada que comparar',

  diagnosis_triangulado: 'Triangulado',
  diagnosis_se_evalua_sin_trabajarse: 'Se evalúa sin trabajarse',
  diagnosis_se_trabaja_sin_evaluarse: 'Se trabaja sin evaluarse',
  diagnosis_sin_trabajar_ni_evaluar: 'Sin trabajar ni evaluar',

  colIndicator: 'Indicador',
  colWorkedBy: 'Se trabaja en',
  colAssessedBy: 'Se evalúa en',
  colDiagnosis: 'Estado',
  colWeek: 'Semana',
  colContainer: 'Módulo / Unidad',
  colPiece: 'Actividad / Evaluación',
  colHours: 'Horas',
  colMoments: 'Momentos',
  colPieces: 'Actividades y Evaluaciones',
  colEvaluation: 'Evaluación',
  colUnitWeek: 'Unidad / Semana',
  colCharacter: 'Carácter',
  colStudentEvidence: 'Evidencia del estudiante',
  colInstrument: 'Instrumento',
  colAgent: 'Agente / Modalidad',
  colWeighing: 'Ponderación',

  noMoment: 'Sin momento',
  noMethod: 'El diseño no tiene un modelo instruccional elegido',
  week: 'S{week}',
  weekRange: 'S{from}-{to}',
  weekNone: 'S/S',
  hoursShort: '{hours} h',
  autonomousShort: '{hours} h autónomas',
  studentsShort: '{students} estudiantes',
  attempts: '{attempts} intento(s)',
  withRubric: 'con rúbrica',
  maxScore: '{score} pts',
  total: 'Total',
  hoursNote:
    'La semana no se guarda: sale de acumular las horas del diseño en su orden. La Asignatura declara {total} horas en {weeks} semanas, es decir {weekly} por semana.',
}
